import * as selectDropdowns from './utils';

import { Button, Form } from 'react-bootstrap';
import { createAuditMutation, editRequestLineItemStatus, updateRequestMutation } from './api';
import { useMutation } from '@apollo/client';
import React from 'react';
import { RequestLineItems } from './components/RequestLineItems';
import Statuses from './components/Statuses';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { AttachmentList } from './components/AttachmentList';
import { NewAttachment } from './components/NewAttachment';
import { Comments } from '../Comments';
import { Controller, useForm } from 'react-hook-form';

interface Props {
  userData: any;
  queryData: any;
  requestItemData: any;
  npData: any;
}

enum barcode_type {
  'No Barcode',
  'Capital',
  'Grants',
  'GASB',
  'Regular',
}

export const EditRequestForm = (props: Props) => {
  const [updateRequest] = useMutation(updateRequestMutation);
  const [editLineItems] = useMutation(editRequestLineItemStatus);
  const [createAudit] = useMutation(createAuditMutation);
  const [comment, setComment] = React.useState('');
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [itemData, setItemData] = React.useState([]);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      attachment: props.queryData.requestById.attachment,
      barcodeType: props.queryData.requestById.barcodeType,
      chargeAccount: props.queryData.requestById.chargeAccount,
      deliveryDate: props.queryData.requestById.deliveryDate,
      deliveryLocation: props.queryData.requestById.deliveryLocation,
      equipmentCategory: props.queryData.requestById.equipmentCategory,
      equipmentType: props.queryData.requestById.equipmentType,
      isCovid: props.queryData.requestById.isCovid,
      needsBarcode: props.queryData.requestById.needsBarcode,
      notes: props.queryData.requestById.notes,
      oitNotes: props.queryData.requestById.oitNotes,
      orderAmount: props.queryData.requestById.orderAmount,
      orderDate: props.queryData.requestById.orderDate,
      orderNumber: props.queryData.requestById.orderNumber,
      propertyCoordinator: props.queryData.requestById.propertyCoordinator,
      propertyCoordinatorId: props.queryData.requestById.propertyCoordinatorId,
      purchaseOrderNumber: props.queryData.requestById.purchaseOrderNumber,
      quantity: props.queryData.requestById.quantity,
      requestDate: props.queryData.requestById.requestDate,
      requestId: parseFloat(props.queryData.requestById.requestId),
      requestingDepartmentName: props.queryData.requestById.requestingDepartment.Name,
      requestNumber: props.queryData.requestById.requestNumber,
      requestorEmail: props.queryData.requestById.requestorEmail,
      requestorName: props.queryData.requestById.requestorName,
      requestorPhoneNumber: props.queryData.requestById.requestorPhoneNumber,
      status: props.queryData.requestById.status,
      statusUpdateQuantity: props.queryData.requestById.quantity,
      statusUpdateStatus: props.queryData.requestById.status,
      vendor: props.queryData.requestById.vendor,
      requestorDivision: props.queryData.requestById.requestorDivision,
      oitStock: props.queryData.requestById.oitStock,
      fulfillingDivision: props.queryData.requestById.fulfillingDivision ? props.queryData.requestById.fulfillingDivision : '',
      fulfillingDepartmentName: props.queryData.requestById.fullfillingDepartmentName
        ? props.queryData.requestById.fullfillingDepartmentName.Name
        : '',
      fulfillingDepartment: props.queryData.requestById.fulfillingDepartment ? props.queryData.requestById.fulfillingDepartment : '',
    },
  });

  React.useEffect(() => {
    setItemData(
      props.requestItemData.requestedItemsByRequestId.filter((item, index) => {
        return item.requestItemFYNumber.includes(props.queryData.requestById.requestNumber);
      })
    );
  }, []);

  const onSubmit = handleSubmit(async (values) => {
    values.needsBarcode === true ? (values.needsBarcode = true) : (values.needsBarcode = false);
    values.quantity = parseFloat(values.quantity);
    values.orderAmount = parseFloat(values.orderAmount);
    values.needsBarcode = values.barcodeType === 'No Barcode' || values.barcodeType === null ? false : true;
    values.propertyCoordinatorId = parseInt(values.propertyCoordinatorId);
    delete values.fulfillingDepartmentName;
    //remove from form values if '', only possible if NULL in REQUEST table
    if (values.fulfillingDepartment === '') delete values.fulfillingDepartment;
    if (values.fulfillingDivision === '') delete values.fulfillingDivision;
    if (values.statusUpdateStatus === 'Ordered' && props.queryData.requestById.status !== 'Ordered') {
      values.orderDate = new Date();
    }
    if (values.status === 'Received' && props.queryData.requestById.status !== 'Received') {
      values.deliveryDate = new Date();
    }
    updateRequest({ variables: values })
      .then((res) => {
        try {
          if (values.status !== values.statusUpdateStatus)
            axios.post(`${(window as any)._env_.REACT_APP_SERVER}/request/statusUpdateEmail`, { userRequest: values }).catch((err) => {
              console.log('Error: frontend/src/components/RequestForms/EditRequestForm/onSubmit//lno125', err);
            });
        } catch (e) {
          alert(e);
        }
        createAuditForAsset(values);
        window.location.reload();
      })
      .catch((err) => {
        console.log('Error: /frontend/src/components/RequestForms/EditRequestForm//onSubmit', err);
      });
  });

  const createAuditForAsset = (formValues) => {
    let commentStr = comment !== '' ? comment : 'Request has been updated';
    const audit = {
      barcode: formValues.barcode,
      createdBy: user.adId,
      lastUpdatedBy: user.adId,
      comment: commentStr,
      updatedOn: new Date(),
      entryType: formValues.status,
      requestId: formValues.requestId,
    };
    createAudit({ variables: audit }).catch((err) =>
      console.log('Error: /frontend/src/components/RequestForms/EditRequestForm//createAuditForAsset', err)
    );
  };

  const handleChecks = (reqItems: any) => {
    setSelectedItems({ ...reqItems, fy: getValues().requestNumber });
  };

  return (
    <React.Fragment>
      <form id='requestForm' onSubmit={onSubmit}>
        <div className='row justify-content-end'>
          <div className='col-sm-8'>
            <Button type='submit' variant='info' className='mt-3 float-left'>
              Save Changes
            </Button>
            <Button className='mt-3 ml-3 float-left' href={'/receiving'}>
              Back
            </Button>

            {props.npData[0] !== -1 && user.currentRole.roleId !== -1 && (
              <Button className='mt-3 ml-3 float-left' variant='danger' href={`/receiving/view/requestId=${props.npData[0]}`}>
                Previous Request
              </Button>
            )}
            {props.npData[1] !== -1 && user.currentRole.roleId !== -1 && (
              <Button className='mt-3 ml-3 float-left' variant='danger' href={`/receiving/view/requestId=${props.npData[1]}`}>
                Next Request
              </Button>
            )}
          </div>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Request #</label>
              <input disabled className='form-control col-sm' {...register('requestNumber')} />
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Status</label>
              <input className='form-control col-sm' disabled {...register('status')} />
            </div>
          </div>
        </div>

        <div className='requestDivider'>Request</div>

        <div className='row'>
          <div className='col-sm-8'>
            <div className='row justify-content-start mt-3'>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Requestor Name</label>
                  <input className='form-control col-sm' {...register('requestorName')} />
                </div>
              </div>
              <div className='col-sm-2'>
                <div className='form-group'>
                  <label>Phone Number</label>
                  <input className='form-control col-sm' {...register('requestorPhoneNumber')} />
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>E-mail</label>
                  <input className='form-control col-sm' {...register('requestorEmail')} />
                </div>
              </div>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>Requesting Department, Division</label>
                  <input
                    disabled
                    value={`${getValues().requestingDepartmentName}, ${getValues().requestorDivision}`}
                    className='form-control col-sm'
                  />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-5'>
                <div className='form-group'>
                  <label>Equipment Type</label>
                  <input className='form-control' {...register('equipmentType')} />
                </div>
              </div>
              <div className='col-sm-3'>
                <div className='form-group'>
                  <label>Equipment Category</label>
                  {/* <Controller 
                  control={control}
                  name='equipmentCategory'
                  render={({field: {onChange, value}}) => (
                    <Typeahead
                    id='equipmentCategory'
                    defaultSelected={selectDropdowns.majorEquipmentClasses.filter((item) => {
                      return value === item.Code
                    })}
                    onChange={(e) => onChange(e[0] ? e[0].Code : null)}
                    labelKey={(option) => `${option.Code} - ${option.Description}`}
                    options={selectDropdowns.majorEquipmentClasses}/>
                  )}/> */}
                  <select className='form-control' {...register('equipmentCategory')}>
                    {selectDropdowns.majorEquipmentClasses.map((value, index) => {
                      return (
                        <option value={value.Code}>
                          {value.Code} - {value.Description}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>Harbor Charge Account</label>
                  <input className='form-control' {...register('chargeAccount')} />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-5'>
                <div className='form-group'>
                  <label>Delivery Location</label>
                  <input className='form-control' {...register('deliveryLocation')} />
                </div>
              </div>
              <div className='col-sm-2'>
                <div className='form-group'>
                  <label>Request Date</label>
                  <input
                    disabled
                    className='form-control'
                    value={getValues().requestDate ? new Date(getValues().requestDate).toLocaleDateString() : ''}
                  />
                </div>
              </div>
              <div className='col-sm-1'>
                <div className='form-group'>
                  <label>Quantity</label>
                  <input className='form-control' {...register('quantity')} />
                </div>
              </div>
              <div className='col-sm-4'>
                <div className='form-group'>
                  <label>Fulfilling Department, Division</label>
                  <input disabled className='form-control' value={`${getValues().fulfillingDepartmentName}, ${getValues().fulfillingDivision}`} />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-12'>
                <div className='form-group'>
                  <label>Notes</label>
                  <textarea rows={6} className='form-control' {...register('notes')} />
                </div>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='col-sm-2'>
                <div className='form-group form-inline'>
                  <Controller
                    control={control}
                    name='isCovid'
                    render={({ field: { onChange, value } }) => (
                      <label>
                        COVID-19 purchase?&nbsp;&nbsp;
                        <Form.Check type='switch' id='isCovid' checked={value} onChange={onChange} />
                      </label>
                    )}
                  />
                </div>
              </div>
              {user.currentRole.departmentId === 19 && (
                <div className='col-sm-2'>
                  <div className='form-group form-inline'>
                    <Controller
                      control={control}
                      name='oitStock'
                      render={({ field: { onChange, value } }) => (
                        <label>
                          OIT Stock purchase?&nbsp;&nbsp;
                          <Form.Check type='switch' id='oitStock' checked={value} onChange={onChange} />
                        </label>
                      )}
                    />
                  </div>
                </div>
              )}
              <div className='col-sm-3'>
                <div className='form-group'>
                  <NewAttachment requestId={getValues().requestId} />
                </div>
              </div>

              {getValues().attachment !== null && getValues().attachment !== '' && <AttachmentList files={getValues().attachment} />}
            </div>
          </div>
          <div className='col-sm-4 mt-3'>
            {/* <div className='row'> */}

            <div className='form-group'>
              <label>Add Comment</label>
              <textarea className='form-control col-sm' id='comment' rows={1} value={comment} onChange={(e) => setComment(e.target.value)} />
            </div>
            <Comments requestId={getValues().requestId} style={{ height: '400px' }} />

            {/* </div> */}
          </div>
        </div>

        <div className='requestDivider'>Order</div>

        <div className='row justify-content-start mt-3'>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Date Ordered</label>
              <input {...register('orderDate')} placeholder='mm/dd/yyyy' className='form-control' />
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Order #</label>
              <input
                {...register('orderNumber', {
                  maxLength: 100,
                })}
                className='form-control'
              />
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Order Amount</label>
              <input {...register('orderAmount')} className='form-control' />
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Ordered By</label>
              <select {...register('propertyCoordinatorId')} className='form-control'>
                {props.userData.map((value, index) => {
                  return <option value={value.id}>{value.name}</option>;
                })}
              </select>
            </div>
          </div>
        </div>
        <div className='row justify-content-start'>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Payment Method</label>
              <select className='form-control col-sm' {...register('purchaseOrderNumber')}>
                {selectDropdowns.pCards.map((value, index) => {
                  return <option value={value.val}>{value.desc}</option>;
                })}
              </select>
            </div>
          </div>
          <div className='col-sm-4'>
            <div className='form-group'>
              <label>Vendor</label>
              <select {...register('vendor')} className='form-control col-sm'>
                {selectDropdowns.manufacturers.map((value, index) => {
                  return (
                    <option value={value.Code}>
                      {value.Code} - {value.Description}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className='col-sm-2'>
            <div className='form-group'>
              <label>Barcode</label>
              <select
                className='form-control'
                {...register('barcodeType')}
                style={{
                  backgroundColor: selectDropdowns.barcodeTypes[barcode_type[getValues().barcodeType]]?.backColor,
                  color: selectDropdowns.barcodeTypes[barcode_type[getValues().barcodeType]]?.textColor,
                }}>
                {selectDropdowns.barcodeTypes.map((value, index) => {
                  return (
                    <option value={value.label} style={{ backgroundColor: value.backColor, color: value.textColor }}>
                      {value.label}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        {itemData.length > 0 && (
          <>
            <div className='requestDivider'>Line Items</div>
            <div className='row justify-content-start'>
              <div className='col-sm-9 mt-2 mb-2'>
                <div className='form-inline'>
                  <Button
                    className='float-left'
                    variant='info'
                    onClick={() => {
                      editLineItems({
                        variables: {
                          json: JSON.stringify(selectedItems),
                          newStatus: getValues().statusUpdateStatus,
                        },
                      })
                        .then((res) => {
                          if (res.data.editRequestLineItems === 'Partially Ordered') setValue('status', res.data.editRequestLineItems);
                          onSubmit();
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }}>
                    Mark Checked Items as
                  </Button>
                  <Controller
                    control={control}
                    name='statusUpdateStatus'
                    render={({ field: { onChange, value } }) => (
                      <Statuses
                        onChange={onChange}
                        idName={'statusUpdateStatus'}
                        value={getValues().statusUpdateStatus}
                        lblClass={''}
                        selClass={'form-control ml-1'}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            {/* </form> */}

            <RequestLineItems handleChecks={handleChecks} data={itemData} />
          </>
        )}

        {user.currentRole.departmentAbbreviation === 'OIT' && (
          // <form onSubmit={onSubmit}>
          <>
            <div className='requestDivider'>OIT Notes</div>

            <div className='row justify-content-start mt-3'>
              <div className='col-sm-8'>
                <div className='form-group'>
                  <textarea rows={6} className='form-control' {...register('oitNotes')} />
                </div>
              </div>
            </div>
            {/* </form> */}
          </>
        )}
      </form>
    </React.Fragment>
  );
};

export default EditRequestForm;
